export default __webpack_public_path__ + "static/media/userImage.7bdf7b93.png";